import { useEffect } from "react";
import { Container, Grid } from "@mui/material";
import BankingBreakdown from "../components/banking/BankingBreakdown";
import { trackEvent } from "src/Amplitude";
import Layout from "src/components/core/Layout";

export default function BankingDetails() {
  useEffect(() => {
    trackEvent("Visit_Page", { page: "Banking_Details" });
  }, []);

  return (
    <Layout>
      <Container>
        <Grid container px={1}>
          <Grid item xs={12}>
            <BankingBreakdown />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
}
